export const buttonNameMapper = {
  0: "placeOrder",
  1: "placeOrder",
  2: "payNow",
  3: "submit",
  4: "continue",
  5: "purchase",
  6: "save",
};
